// import { currencyUnitMap } from '@/constants/currency'
import {
  getProjectTableColumn,
  getBrandTableColumn,
  getAccountTableColumn,
  getRegionTableColumn,
  getStatusTableColumn,
  getCopyWithContentTableColumn,
} from '@/utils/common/tableColumn'
import { hasMeterService } from '@/utils/auth'
import { numerify } from '@/filters'
import i18n from '@/locales'
import { SUGGEST_RULE_RESOURCE_TYPES_MAP } from '@Bill/constants'
import {
  getPeriodTableColumn,
  getTimeFromTableColumn,
  getSuggestRuleTableColumn,
  getSuggestMethodTableColumn,
  // getSuggestInfoTableColumn,
  getPublicScopeTableColumn,
} from '@Bill/utils/columns'

export default {
  created () {
    const columns = [
      // 规则字段
      {
        field: 'rule_name',
        title: i18n.t('meter.rule_name'),
        isResHide: true,
        slots: {
          default: ({ row }) => {
            return [
              <div class='text-truncate'>
                <list-body-cell-wrap copy row={row} field='rule_name' title={row.rule_name} />
                {/* <list-body-cell-wrap copy row={row} field='id' hideField title={row.rule_id}><span style="color: #999;">{row.rule_id}</span></list-body-cell-wrap> */}
              </div>,
            ]
          },
        },
        formatter: ({ row }) => {
          return row.rule_name
        },
      },
      {
        field: 'res_name',
        title: i18n.t('bill.text_127'),
        sortable: true,
        slots: {
          default: ({ row }) => {
            return [
              <div class='text-truncate'>
                <list-body-cell-wrap copy row={row} field='res_name' title={row.res_name} hideField={true}>
                  {this.group_by === 'res' ? <side-page-trigger permission='suggestsysalerts_get' name='SuggestsAlertSidePage' id={row.res_id} vm={this} onTrigger={() => this.handleOpenSidepage(row)}>{row.name}</side-page-trigger> : row.name}
                </list-body-cell-wrap>
                <list-body-cell-wrap copy row={row} field='res_id' hideField title={row.res_id}><span style="color: #999;">{row.res_id}</span></list-body-cell-wrap>
              </div>,
            ]
          },
        },
        formatter: ({ row }) => {
          return row.name
        },
      },
      getCopyWithContentTableColumn({
        field: 'ip_addr',
        title: 'IP',
        minWidth: 140,
      }),
      getSuggestRuleTableColumn(),
      {
        field: 'resource_type',
        title: this.$t('bill.text_73'),
        formatter: ({ row }) => {
          return SUGGEST_RULE_RESOURCE_TYPES_MAP[row.res_type].label
        },
      },
      // getSuggestInfoTableColumn(),
      getPeriodTableColumn(),
      getTimeFromTableColumn(),
      getSuggestMethodTableColumn(),
      getPublicScopeTableColumn(),
      // 资源字段
      getStatusTableColumn({ statusModule: 'suggestsysalert', title: this.$t('meter.suggest_status') }),
      // getTypeTableColumn(),
      // getRuleNameTableColumn(),
      // getSuggestTableColumn(),
      {
        field: 'usage_type',
        title: this.$t('bill.usage_type'),
      },
      {
        field: 'origin_usage',
        title: this.$t('meter.origin_usage'),
      },
      {
        field: 'suggest_usage',
        title: this.$t('meter.suggest_usage'),
      },
      {
        field: 'usage_unit',
        title: this.$t('meter.usage_unit'),
      },
      {
        field: 'month',
        title: this.$t('bill.month'),
      },
      getCopyWithContentTableColumn({
        field: 'host',
        title: this.$t('dictionary.host'),
        isTypeHide: true,
        minWidth: 140,
      }),
      getCopyWithContentTableColumn({
        field: 'host_ip',
        title: this.$t('dictionary.hostip'),
        isTypeHide: true,
        minWidth: 140,
      }),
    ]

    if (!this.$route.path.startsWith('/iam') && hasMeterService()) {
      columns.push({
        field: 'amount',
        title: i18n.t('bill.text_182'),
        minWidth: 70,
        sortable: true,
        showOverflow: 'title',
        slots: {
          header: ({ column }) => {
            return [
              <a-tooltip>
                <template slot="title">
                  <div>{ this.$t('bill.amount_tips_2') }</div>
                  <div>{ this.$t('bill.amount_tips_3') }</div>
                  <div>{ this.$t('bill.amount_tips_4') }</div>
                </template>
                <span class='mr-1'>{ column.title }</span>
                <icon type="question" />
              </a-tooltip>,
            ]
          },
          default: ({ row }, h) => {
            const price = numerify(row.amount, '0,0.00')
            const currencyUnit = this.currencySign
            if (!price) {
              return '-'
            }
            return [
              <span class="success-color"><a-icon type="fall" /> {currencyUnit}{ price }</span>,
            ]
          },
        },
        formatter: ({ row }) => {
          const price = numerify(row.amount, '0,0.00')
          const currencyUnit = this.currencySign
          if (!price) {
            return '-'
          }
          return `${currencyUnit}${price}`
        },
      })
      columns.push({
        field: 'year_amount',
        title: i18n.t('bill.text_182_2'),
        minWidth: 70,
        sortable: true,
        showOverflow: 'title',
        slots: {
          default: ({ row }, h) => {
            const price = numerify(row.year_amount, '0,0.00')
            const currencyUnit = this.currencySign
            if (!price) {
              return '-'
            }
            return [
              <span class="success-color"><a-icon type="fall" /> {currencyUnit}{price}</span>,
            ]
          },
        },
        formatter: ({ row }) => {
          const price = numerify(row.year_amount, '0,0.00')
          const currencyUnit = this.currencySign
          if (!price) {
            return '-'
          }
          return `${currencyUnit}${price}`
        },
      })
    }

    columns.push(getBrandTableColumn({ field: 'provider' }))
    columns.push(getAccountTableColumn())
    columns.push(getProjectTableColumn({ title: this.$t('meter.resource_belong_project') }))
    columns.push(getRegionTableColumn({ field: 'cloudregion' }))
    this.columns = columns
  },
}
